import React from "react";
import { cls } from "@wss/cls";
import FilterListItem from "./FilterListItem";
import StandardIcon from "~/common/Icons/Standard";
import { GroupProps } from "./GroupProps";

const PlusFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  prefetch,
}: GroupProps) => {
  return (
    <>
      {groups.map((group) => (
        <li
          data-test="PlusFilter"
          key="plus"
          className="border-gray-200 border-solid border-0 lt:border-y mt-0 xs:mt-px lt:mt-[3px] first:border-t"
        >
          <button
            type="button"
            className={cls(
              group.collapsed && "collapsed mb-px",
              "bg-white",
              "border-gray-200",
              "border-solid",
              "border-0",
              "block",
              "font-semibold",
              "text-base-1/2",
              "pl-2",
              "pr-3",
              "pt-1-1/2",
              "pb-px",
              "lt:py-0",
              "sticky",
              "-top-[1px]",
              "text-left",
              "text-gray-800",
              "w-full",
              "lt:font-bold",
              "lt:text-sm-1/2",
              "lt:relative",
              "leading-6",
              "align-middle",
              "focus:outline-offset-[-3px]",
              "z-10"
            )}
            onClick={() => toggleCollapsed(group)}
            aria-expanded={!group.collapsed}
          >
            <span>{group.groupName}</span>
            <StandardIcon
              name="chevron-open"
              style={{
                right: 12,
                color: "#ccc",
                top: "50%",
              }}
              className={cls(
                "h-2",
                "absolute",
                "fill-current",
                "w-2",
                "transform",
                "-translate-y-1/2",
                "transition-all",
                "ease-in",
                "duration-300",
                group.collapsed && "rotate-180"
              )}
            />
          </button>
          <ul
            className={cls(
              group.collapsed &&
                "hidden h-0 overflow-hidden relative transition-all ease-in-out duration-300",
              "bg-white m-0 pl-4-1/2 lt:bg-transparent lt:p-0 pr-1 lt:pr-0"
            )}
          >
            {group.groupItems.map((groupItem) => (
              <FilterListItem
                groupsWithMultipleSelections={groupsWithMultipleSelections}
                groupItem={groupItem}
                prefetch={prefetch}
                key={groupItem.nameEncoded}
                groupNameEncoded={group.groupNameEncoded}
                filterText="filter"
                labelImageUrl="//cdnimg.webstaurantstore.com/uploads/design/2017/8/plus_micro.svg"
                labelImageWidth="32px"
                customLinkClass="focus:outline-offset-[-3px] mb-px lt:mb-px"
              />
            ))}
          </ul>
        </li>
      ))}
    </>
  );
};

export default PlusFilter;
